export const signUpPages = Object.freeze({
  userData: 'userData',
  billingPlan: 'billingPlan',
  cardData: 'cardData',
});

export default {};
